const not_implemented = () => {debugger; console.log('[ERR] data translation func is not implemented')}
const identity = x => x

// display
const display_string = dst => str => {
    if (!str) {return}

    switch (dst) {
        case 'string':
        case 'multi-line-string': 
        case 'image': 
        case 'single-select':
        case 'single-select-as-is':
        case 'datetime':
            if (!str) {
                return ''
            }
            return str
        case 'multi-string': 
            return str? str.split(';') : []
        case 'forestry-data': 
            return str? JSON.parse(str): []
        case 'multiple-select-as-is':
            return str? str.split(';') : []
        default: 
            return not_implemented()
    }
}
const display_digital_type = dst => str => {
    if (!str) {return}

    switch (dst) {
        case 'string':
            switch(str) {
                case 'doc':
                    return '文件'
                case 'image':
                    return '圖片'
                case 'video':
                    return '影片'
                case 'audio':
                    return '音訊'
            }
        default: 
            return not_implemented()
    }
}
const display_datetime = dst => datetime => {
    switch (dst) {
        case 'string': 
            if (!datetime) {
                return ''
            }
            return datetime? (datetime['date'].substring(0, datetime['date'].length-7) || 'Invalid datetime') : ''
        default: 
            return not_implemented()
    }
}

const display_file_url = dst => url => {
    switch (dst) {
        case 'string': 
            if (!url) {
                return ''
            }
            return url
        default: 
            return not_implemented()
    }
}


const display_image_url = dst => url => {
    switch (dst) {
        case 'image': 
            if (!url) {
                return ''
            }
            return url
        default: 
            return not_implemented()
    }
}

const display_role_array = dst => roles => {

    switch (dst) {
        case 'string': 
            if (!roles) {
                return ''
            }
            return roles[0]['role_name']
        default: 
            return not_implemented()
    }
}

const display_cover_image = dst => cover_image => {
    switch (dst) {
        case 'image': 
            if (!cover_image) {
                return ''
            }else if(cover_image.length > 0 && 'path' in cover_image[0]) {
                return cover_image[0]['path']
            }else {
                return ''
            }
        default: 
            return not_implemented()
    }
}

const display_json = dst => json => {

    switch (dst) {
        case 'multi-value': {
            if (!json) {
                return ''
            }
            let ret = ''
            
            

            return ret
        }
        default: 
            return not_implemented()
    }
}


const field_to_display = (src, dst) => //field_to_display(SRC)(DST) = function translate from 
{   
    switch(src) {
        case 'string': return display_string(dst)
        case 'digital_type': return display_digital_type(dst)
        case 'string-array': return not_implemented
        case 'datetime': return display_datetime(dst)
        case 'file_url': return display_file_url(dst)
        case 'image_url': return display_image_url(dst)
        case 'role-array': return display_role_array(dst)
        case 'cover_image': return display_cover_image(dst)
        case 'json': return display_json(dst)
        default: return not_implemented()
    }
}

// edit
const edit_string = dst => str => {

    switch (dst) {
        case 'string': 
        case 'password': 
        case 'multi-line-string': 
        case 'single-select': 
        case 'single-select-as-is': 
        case 'datetime':
            if (!str) {
                return ''
            }
            return str
        case 'multi-string': 
            if (typeof str === 'string' && str !== '') {
                return str.split(';')
            }
            return []
        case 'forestry-data': 
            return str? JSON.parse(str): []
        case 'multiple-select-as-is':
            return str? str.split(';') : []
        default: return not_implemented()
    }
}
const edit_datetime = dst => datetime => {
    switch (dst) {
        case 'string':
        case 'datetime': 
            if (!datetime) {return ''}
            return datetime? (datetime['date'].substring(0, datetime['date'].length-7) || 'Invalid datetime') : ''
        default: return not_implemented()
    }
}

const edit_role_array = dst => roles => {
    switch (dst) {
        case 'single-select': 
            if (!roles) {return null}
            return roles[0]['role_id']
        default: 
            return not_implemented()
    }
}

const edit_file_list = dst => params => {
    switch(dst) {
        case 'upload-file-with-list-table':
            return params!==null?params:not_implemented()
        default:
            return not_implemented()
    }
}

const field_to_edit = (src, dst) =>
{
    switch(src) {
        case 'string': return edit_string(dst)
        case 'string-array': return not_implemented
        case 'datetime': return edit_datetime(dst)
        case 'file_url': return not_implemented
        case 'image_url': return not_implemented
        case 'role-array': return edit_role_array(dst)
        case 'file_list': return edit_file_list(dst)
        default: return not_implemented()
    }
}


// back to source
const source_string = dst => str => {
    if (typeof str === 'undefined' || str === null) {return}

    switch (dst) {
        case 'string':
        case 'multi-line-string': 
        case 'single-select': 
        case 'single-select-as-is': 
            return str
        case 'datetime':
            if (!str) {return}
            return str
        default: return not_implemented()
    }
}
const source_multi_string = dst => mstr => {
    if (typeof mstr === 'undefined' || mstr === null) {return}

    switch (dst) {
        case 'string': return mstr? mstr.join(';'): ''
        default: return not_implemented()
    }
}
const source_multi_line_string = dst => mstr => {
    if (typeof mstr === 'undefined' || mstr === null) {return}

    switch (dst) {
        case 'string': return mstr
        default: return not_implemented()
    }
}
const source_single_select = dst => choice => {
    if (typeof choice === 'undefined' || choice === null) {return}

    switch (dst) {
        case 'string': return choice
        case 'role-array': return choice
        default: return not_implemented()
    }
}
const source_datetime = dst => datetime => {
    if (typeof datetime === 'undefined' || datetime === null) {return}

    switch (dst) {
        case 'string':
        case 'datetime': 
            if (!datetime) {return}
            return datetime
        default: return not_implemented()
    }
}

const source_forestry_data = dst => data => {
    if (typeof data === 'undefined' || data === null) {return}

    switch (dst) {
        case 'string':
            if (!data) {return}
            return JSON.stringify(data)
        default: return not_implemented()
    }
}

const source_multi_select = dst => mstr => {
    if (typeof mstr === 'undefined' || mstr === null) {return}

    switch (dst) {
        case 'string': return mstr? mstr.join(';'): ''
        default: return not_implemented()
    }
}

const field_to_source = (src, dst) => 
{
    switch(src) {
        case 'string': return source_string(dst)
        case 'password': return source_string(dst)
        case 'multi-line-string': return source_multi_line_string(dst)
        case 'multi-string': return source_multi_string(dst)
        case 'single-select': return source_single_select(dst)
        case 'single-select-as-is': return identity
        case 'string-array': return not_implemented
        case 'datetime': return source_datetime(dst)
        case 'file_url': return not_implemented
        case 'image_url': return not_implemented
        case 'forestry-data': return source_forestry_data(dst)
        case 'multiple-select-as-is': return source_multi_select(dst)
        default: return not_implemented()
    }
}

// entry
function data_to_display ({structure, data, params}) {
    if (!data || !structure) {
        return
    }
    else if (structure['fields'] && Array.isArray(structure['fields'])) {
        for (let field of structure['fields']) {
            data_to_display({structure: field, data, params})
        }
    }
    else if (Array.isArray(structure)) {
        for (let field of structure) {
            data_to_display({structure: field, data, params})
        }
    }
    else {
        if (params['partial'] && !data[structure['source']['key']]) {
            return
        }

        let ret = field_to_display(structure['source']['data_type'], structure['display']['type'])(data[structure['source']['key']])
        if (ret) {
            data[structure['source']['key']] = ret
        }
    }
}

function data_to_edit ({structure, data, params}) {
    if (!data || !structure) {
        return
    }
    else if (params['mode'] !== 'add' && params['mode'] !== 'edit') {
        console.warn('[ERR] pageStructureMixin: data_to_edit: invalid mode=', params['mode'])
        debugger
        return
    }
    else if (structure['fields'] && Array.isArray(structure['fields'])) {
        for (let field of structure['fields']) {
            data_to_edit({structure: field, data, params})
        }
    }
    else if (Array.isArray(structure)) {
        for (let field of structure) {
            data_to_edit({structure: field, data, params})
        }
    }
    else {
 
        if ( (structure['change']['editable'] && params['mode'] === 'edit') || 
            (structure['change']['addable'] && params['mode'] === 'add')) {
            if (structure['change']['type'] === 'single-select' && ['vuex'].indexOf(structure['change']['options']['type']) !== -1) {
                if (params['partial'] && !data[structure['source']['key']]) {
                    return
                }

                let ret = field_to_edit(structure['source']['data_type'], structure['change']['type'])(data[structure['source']['key']])

                if (typeof ret !== 'undefined' && ret !== null) {
                    data[structure['change']['name']] = ret
                }
            }
            else if (structure['change']['type'] === 'single-select' && ['db'].indexOf(structure['change']['options']['type']) !== -1) {
                if (params['partial'] && !data[structure['change']['name']]) {
                    return
                }

                let ret = field_to_edit(structure['source']['data_type'], structure['change']['type'])(data[structure['change']['name']])

                if (typeof ret !== 'undefined' && ret !== null) {
                    data[structure['change']['name']] = ret
                }
            }
            else if (structure['change']['type'] === 'upload-file-with-list-table') {
                if (params['partial'] && !data[structure['change']['name']]) {
                    return
                }

                let ret = field_to_edit(structure['source']['data_type'], structure['change']['type'])(data[structure['change']['name']])

                if (typeof ret !== 'undefined' && ret !== null) {
                    data[structure['change']['name']] = ret
                }
            }
            else {
                let ret = field_to_edit(structure['source']['data_type'], structure['change']['type'])(data[structure['source']['key']])
                if (params['partial'] && typeof data[structure['source']['key']] === 'undefined') {
                    return
                }

                if (typeof ret !== 'undefined' && ret !== null) {
                    data[structure['source']['key']] = ret
                }
            }
        }
        else {
            if (params['partial'] && typeof data[structure['source']['key']] === 'undefined') {
                return
            }

            let ret = field_to_display(structure['source']['data_type'], structure['display']['type'])(data[structure['source']['key']])
            if (typeof ret !== 'undefined' && ret !== null) {
                data[structure['source']['key']] = ret
            }
        }
    }
}

function data_to_source ({structure, data, get_key_value}) {
    if (!data || !structure) {
        return
    }
    else if (structure['fields'] && Array.isArray(structure['fields'])) {
        for (let field of structure['fields']) {
            data_to_source({structure: field, data, get_key_value})
        }
    }
    else if (Array.isArray(structure)) {
        for (let field of structure) {
            data_to_source({structure: field, data, get_key_value})
        }
    }
    else {
        if (structure['change']['editable'] || structure['change']['addable']) {
            if (structure['change']['type'] === 'single-select' && ['db','vuex'].indexOf(structure['change']['options']['type']) !== -1) {
                if (structure['change']['name'].indexOf('fk_') !== -1 && 
                  (!data[structure['change']['name']] || data === '')) {
                    // not setting foreign key when it is not valid
                    console.log('[WARN] pageStructureMixin: skip empty foreign key:', structure['change']['name'] )
                    return
                }
                let ret = field_to_source(structure['change']['type'], structure['source']['data_type'])(data[structure['change']['name']])
                get_key_value(structure['change']['name'], ret)
            }
            else {
                let ret = field_to_source(structure['change']['type'], structure['source']['data_type'])(data[structure['source']['key']])
                if (typeof ret !== 'undefined' && ret !== null) {
                    get_key_value(structure['source']['key'], ret)
                }
            }
        }
        else {
            console.log('[WARN] pageStructureMixin: skip field: ', structure['display']['type'])
            // let ret = field_to_source(structure['display']['type'], structure['source']['data_type'])(data[structure['source']['key']])
            // get_key_value(structure['source']['key'], ret)
        }
    }
}

export default {
    methods: {
        translate_to_display_data(page_structure, data, params) {
            if (!page_structure || !data) {
                console.log('[ERR] pageStructureMixin: invalid data or structure')
                return null
            }
            let clone = Object.assign({}, data)
            data_to_display({structure: page_structure, data: clone, params: params || {}})
            return clone
        },
        translate_to_edit_data(page_structure, data, params) {
            if (!page_structure || !data) {
                console.log('[ERR] pageStructureMixin: invalid data or structure')
                return null
            }
            let clone = Object.assign({}, data)
            data_to_edit({structure: page_structure, data: clone, params: params || {}})
   
            return clone
        },
        translate_to_form_data(page_structure, data) {
            if (!page_structure || !data) {
                console.log('[ERR] pageStructureMixin: invalid data or structure')
                return null
            }
            let form_data = new FormData(); 
            let clone = Object.assign({}, data)
            data_to_source({
                structure: page_structure, 
                data: clone,
                
                get_key_value: (key, value) => {
                    if (typeof value !== 'undefined') {
                        form_data.append(key, value)
                    }
                }
            })
            return form_data
        },
        forge_context_container(page_structure, container) {
            let temp = {}

            if (container) {
                for (let key in container) {
                    temp[key] = JSON.parse(JSON.stringify(container[key]))
                }
            }

            for (let section of page_structure['fields']) {
                for (let field of section['fields'] || [section]) {

                    if ((field['change']['editable'] || field['change']['addable']) && field['change']['type'] === 'multi-string') {
                        if (!temp[field['source']['key']]) {
                            temp[field['source']['key']] = []
                        }
                    }
                    else {
                        if (!temp[field['source']['key']]) {
                            temp[field['source']['key']] = null
                        }

                        if (field['change']['name'] && !temp[field['change']['name']]) {
                            if (field['change']['type'] === 'multiple-file') {
                                temp[field['change']['name']] = []
                            }
                            else {
                                temp[field['change']['name']] = null
                            }
                        }
                    }
                }
            }

            return temp
        },
        retrieve_validation_rule (page_structure) {
            let rules = {}
            for (let section of page_structure['fields']) {
                for (let field of section['fields'] || [section]) {
                    if ((field['change']['editable'] || field['change']['addable']) && field['change']['validator']) {
                        if (typeof field['change']['name'] !== 'undefined') {
                            rules[field['change']['name']] = field['change']['validator']
                        }
                        else {
                            rules[field['source']['key']] = field['change']['validator']
                        }
                    }
                }
            }
            return rules
        }
    }
}